
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.en.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-tutorial-plugins-minimap-demo-plugin-minimap"],
  getter: () => import(/* webpackChunkName: "meta__docs__en" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/tutorial/plugins/minimap.en.md?type=demo')
};